import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=d157310a"
import script from "./NavMenuItem.vue?vue&type=script&lang=js"
export * from "./NavMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/alidata/server/jenkins/workspace/sunion-prod-web-os/03SRC/web-os/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d157310a')) {
      api.createRecord('d157310a', component.options)
    } else {
      api.reload('d157310a', component.options)
    }
    module.hot.accept("./NavMenuItem.vue?vue&type=template&id=d157310a", function () {
      api.rerender('d157310a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/layout/NavMenuItem.vue"
export default component.exports